import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regolamento',
  templateUrl: './regolamento.component.html',
  styleUrls: ['./regolamento.component.css']
})
export class RegolamentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
